import React from 'react';
// import loaderSvg  from './loader.svg';
import './Loading.scss';

const FuturisticLoader = () => {
  return (
    <div className="futuristic-loader-container">
      <div className="futuristic-loader">
        <div className="ring ring1"></div>
        <div className="ring ring2"></div>
      </div>
    </div>
  );
};

export default FuturisticLoader;
